import request from 'helpers/request';
import storage from 'helpers/storage';
// eslint-disable-next-line import/no-unresolved
import api from 'config';
import { source } from 'apis';

export const changePasswordAPI = (params) =>
  request({
    url: `${api.config.authAPI}/vendys/v1/password`,
    method: 'put',
    data: params,
    timeout: 5000
  });

export const changePasswordIgnoreAPI = () =>
  request({
    url: `${api.config.authAPI}/vendys/v1/password/ignore`,
    method: 'put',
    timeout: 5000
  });

export const meAPI = (params) =>
  request({
    url: `${api.config.companyAPI}/addons/v1/me`,
    params
  });

export const mePaymentAPI = async (params) => {
  const result = await request({
    url: `${api.config.companyAPI}/captain-payment/pass/v1/me`,
    params,
    cancelToken: source.token
  });

  // 토큰이 없으면 request가 요청을 보내지 않고 undefined를 반환한다
  if (
    result &&
    result.data &&
    result.data.companyInfo &&
    result.data.companyInfo.userCount &&
    typeof result.data.companyInfo.userCount === 'number'
  ) {
    storage.set('userCount', { userCount: result.data.companyInfo.userCount });
  }
  return result;
};

export const serviceSikdaeAPI = (params) =>
  request({
    url: `${api.config.companyAPI}/captain-payment/pass/v1/service/sikdea`,
    params
  });
